import configs from '../config';
import { fetchWithTenant } from '../utils/apiClient';

const API_URL = `${configs.BACKEND_URL}/api/auth/step-up`;

/**
 * Verify password and obtain a step-up token for sensitive actions.
 */
export async function verifyStepUp(password) {
  const response = await fetchWithTenant(`${API_URL}/verify`, {
    method: 'POST',
    body: JSON.stringify({ password }),
    credentials: 'include',
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Step-up verification failed');
  }

  return response.json();
}

/**
 * Get the list of sensitive actions that require step-up auth.
 */
export async function getSensitiveActions() {
  const response = await fetchWithTenant(`${API_URL}/actions`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch sensitive actions');
  }

  return response.json();
}
